const READ_ONLY_CATEGORIES_NAME_ID = [
  'forums_cat_news_and_announcements',
];

export default READ_ONLY_CATEGORIES_NAME_ID;
